<template>
  <BaseFilters
    :bem="bemBlock"
    :disabled="loading"
    :filter-display-name="filterDisplayName"
    :options="options"
    :selected="refinementSelectedOptions"
    :show="options && options.length > 1"
    @select="selectFilter"
    @deselect="deselectFilter"
  >
    <template #optionContent="slotProps">
      <img
        :class="bemElement('option-image')"
        :src="slotProps.option.image"
        :alt="`${filterDisplayName} ${slotProps.option.displayValue}`"
      >
      {{ slotProps.option.displayValue }}
    </template>
  </BaseFilters>
</template>

<script>
import bemClassesMixin from '../mixins/bemClassesMixin';
import BaseFilters from './BaseFilters.vue';

export default {
  name: 'BaseFiltersColor',

  components: {
    BaseFilters,
  },

  mixins: [
    bemClassesMixin,
  ],

  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    refinement: {
      type: Object,
      default: () => ({}),
    },
    selected: {
      type: Array,
      default: () => ([]),
    },
  },

  data: () => ({
    selectedOptions: null,
  }),

  computed: {
    filterDisplayName() {
      return this.$msg('filters.color.text', 'filters');
    },
    options() {
      return this.refinement?.values;
    },
    refinementAttributeID() {
      return this.refinement?.values?.[0]?.id;
    },
    refinementSelectedOptions() {
      return this.selected?.filter(
        (selectedOption) => (selectedOption.id === this.refinementAttributeID),
      );
    },
  },

  methods: {
    selectFilter(option) {
      this.$emit('select', option);
    },
    deselectFilter(option) {
      this.$emit('deselect', option);
    },
  },
};
</script>
